import React, { useState } from 'react';
import './BhagyankCalculator.css'; // We will create this file for Calculator specific styles

function BhagyankCalculator() {
  const [dob, setDob] = useState('');
  const [bhagyank, setBhagyank] = useState(null);
  const [error, setError] = useState('');

  // Function to calculate Bhagyank
  const calculateBhagyank = (dateString) => {
    // Remove non-digit characters from the date string
    const digitsOnly = dateString.replace(/\D/g, '');

    // Check if the input is a valid date format DDMMYYYY
    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    const day = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const year = parseInt(digitsOnly.substring(4, 8), 10);

    // Basic date validation (e.g., month between 1-12, day between 1-31)
    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) { // Example year range
      return null; // Invalid date components
    }

    // Sum all digits of the date
    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    // Reduce to a single digit
    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setBhagyank(null);

    // Validate date format (DD/MM/YYYY)
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = calculateBhagyank(dob);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setBhagyank(calculated);
    }
  };

  // Explanation for each Bhagyank number (simplified for example)
  const getBhagyankExplanation = (num) => {
    switch (num) {
      case 1:
        return "Bhagyank 1: Represents leadership, independence, and new beginnings. You are a pioneer.";
      case 2:
        return "Bhagyank 2: Signifies cooperation, diplomacy, and balance. You are a peacemaker.";
      case 3:
        return "Bhagyank 3: Denotes creativity, self-expression, and social interaction. You are an artist.";
      case 4:
        return "Bhagyank 4: Symbolizes stability, hard work, and practicality. You are a builder.";
      case 5:
        return "Bhagyank 5: Indicates freedom, adventure, and adaptability. You are a free spirit.";
      case 6:
        return "Bhagyank 6: Represents responsibility, nurturing, and harmony. You are a caregiver.";
      case 7:
        return "Bhagyank 7: Signifies introspection, spiritual growth, and analysis. You are a seeker.";
      case 8:
        return "Bhagyank 8: Denotes ambition, material success, and power. You are a leader.";
      case 9:
        return "Bhagyank 9: Symbolizes humanitarianism, compassion, and completion. You are a philanthropist.";
      default:
        return "";
    }
  };

  return (
    <div className="bhagyank-calculator container my-8">
      <h1 className="text-center text-primary">Bhagyank Calculator</h1>
      <p className="text-center">Enter your Date of Birth to discover your Bhagyank (Destiny Number).</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Bhagyank</button>
      </form>

      {bhagyank !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Bhagyank is: <span className="bhagyank-number">{bhagyank}</span></h2>
          <p className="bhagyank-explanation">{getBhagyankExplanation(bhagyank)}</p>
        </div>
      )}
    </div>
  );
}

export default BhagyankCalculator;
